// src/stores/pathsStore.ts
// Zustand store for the /paths card list — survives navigation, so returning
// to /paths renders the cached cards INSTANTLY while a background refresh
// runs (stale-while-revalidate). Pairs with the backend's Redis cache: Redis
// makes the API fast, this makes the revisit render immediate.

import { create } from 'zustand';
import { PathSummary } from '../types/paths';

interface PathsState {
  // null = never loaded this session (show skeletons); [] = loaded, no paths
  summaries: PathSummary[] | null;
  setSummaries: (s: PathSummary[]) => void;
  // Optimistic insert after generating a path — the list is correct the
  // moment the user navigates back, no refetch needed.
  prependSummary: (s: PathSummary) => void;
  clear: () => void;
}

export const usePathsStore = create<PathsState>((set) => ({
  summaries: null,
  setSummaries: (s) => set({ summaries: s }),
  prependSummary: (s) =>
    set((state) => ({
      summaries: [s, ...(state.summaries ?? []).filter((p) => p.path_id !== s.path_id)],
    })),
  clear: () => set({ summaries: null }),
}));
